import { UnsubscribeReason } from 'root-constants'

export const FEMI_REASON_VALUES = [
  UnsubscribeReason.TOO_EXPENSIVE,
  UnsubscribeReason.DO_NOT_LIKE_PROGRAM,
  UnsubscribeReason.DID_NOT_GET_WHAT_EXPECTED,
  UnsubscribeReason.TIMING_IS_NOT_RIGHT,
  UnsubscribeReason.TECH_ISSUES,
  UnsubscribeReason.OTHER,
]
